import { render, staticRenderFns } from "./MegaMenuMobile.vue?vue&type=template&id=0b289c86&scoped=true"
import script from "./MegaMenuMobile.vue?vue&type=script&lang=js"
export * from "./MegaMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuMobile.vue?vue&type=style&index=0&id=0b289c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b289c86",
  null
  
)

export default component.exports